// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2AzyF","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1EQxa"};